import {
	START_LOGIN,
	LOGIN_SUCCESS,
	LOGIN_ERROR,
	LOGOUT,
	SET_PROFILE,
} from '../mutations.js'

const state = {
	username: localStorage.getItem('username'),
	apiKey: localStorage.getItem('apiKey'),
	superuser: localStorage.getItem('superuser'),
	roles: localStorage.getItem('roles'),
}

const mutations = {
	[SET_PROFILE](state, value) {
		localStorage.setItem('username', value.username)
		localStorage.setItem('apiKey', value['api-key'])
		localStorage.setItem('superuser', value.superuser)
		localStorage.setItem('roles', value.roles)
		state.username = value.username
		state.apiKey = value['api-key']
		state.superuser = value.superuser
		state.roles = localStorage.getItem('roles')
	},
}

const actions = {
	login({
		commit
	}) {
		return new Promise(resolve => {
			setTimeout(() => {
				this.$http.get('me').then(
					(response) => {
						if (response.status != 200) {
							commit(LOGIN_ERROR, response.data.message)
						} else {
							commit(SET_PROFILE, response.data)
						}
						resolve();
					}
				)
			}, 500);
		});
	},
}

export default {
	actions,
	state,
	mutations
}
